import {List, ListItem, Drawer, ListItemText,Collapse,ListItemIcon,ListItemButton} from '@mui/material';
import WebTheme  from "./SubComponentes/WebTheme";
import React,{} from "react";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';

export default  function MenuLateral({estilo,lateralMenuOptions,lateralMenuSubOptions,openSubMenu,lateralMenuOnClick,lateralMenuSubOptionsOnClick}){
    return (
        <Drawer
            variant="permanent"
            anchor="left"
            sx={{
                '& .MuiDrawer-paper': {
                    top: '20%',
                    width: 220,
                    // Sin altura fija para permitir expansión al hacer click
                    boxSizing: 'border-box',
                    backgroundColor: estilo.background,
                    color: (estilo.background === 'black')?estilo.color:WebTheme.colors.letraGreenRotulo ,
                }
            }}
        >
            {/* Lista de opciones principales del menu lateral */}
            <List>
                {lateralMenuOptions.map((item, index) => (
                    <React.Fragment key={index}> {/* React.Frament sirve para encapsular contenido sin usar div o Box */}
                        <ListItemButton
                            onClick={() => lateralMenuOnClick(index)}
                            sx={{
                                height: 70,
                                '&:hover': {
                                    backgroundColor: WebTheme.colors.backgroundHoverGreen,
                                    color: WebTheme.colors.optionBlue,
                                }
                            }}
                        >
                            <ListItemText
                                primary={item}
                                sx={{
                                    '& .MuiTypography-root': {
                                        fontWeight: 'bold',
                                        fontSize: WebTheme.fontSizes.mediano
                                    }
                                }}
                            />
                            {openSubMenu === index ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                        {/* Subopciones específicas de la opción pulsada */}
                        <Collapse in={openSubMenu === index} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {(lateralMenuSubOptions[index] || []).map((suboption, subIndex) => (
                                    <ListItem
                                        key={subIndex}
                                        disablePadding
                                    >
                                        <ListItemButton
                                            id={suboption}
                                            onClick={lateralMenuSubOptionsOnClick}
                                            sx={{
                                                pl: 4,
                                                '&:hover': {
                                                    backgroundColor: WebTheme.colors.backgroundHoverCyan,
                                                    color: WebTheme.colors.optionBlue,
                                                },
                                            }}
                                        >
                                            <ListItemIcon sx={{ color: WebTheme.colors.letraGreenRotulo }}>
                                                <StarBorder />
                                            </ListItemIcon>

                                            <ListItemText primary={suboption} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </React.Fragment>
                ))}
            </List>
        </Drawer>
    )
}